import React from 'react';
import Popover from '@material-ui/core/Popover';
import { BlockPicker } from 'react-color';
import { Tooltip, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import StopIcon from '@material-ui/icons/Stop';

interface BlockColourPickerProps {
  handleColourChange: (colour: any) => void;
  colour: string;
}

export default function BlockColourPicker({ handleColourChange, colour }: BlockColourPickerProps) {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'colour-popover' : undefined;

  const handleColourChangeInternal = (colour: any) => {
    handleColourChange(colour);
    handleClose();
  };

  return (
    <div>
      <Tooltip arrow title={t('f-diseases-colour')}>
        <IconButton size="medium" onClick={handleClick}>
          <StopIcon htmlColor={colour} fontSize="large" />
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <BlockPicker color={colour} onChangeComplete={handleColourChangeInternal} />
      </Popover>
    </div>
  );
}
